import * as React from 'react';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../Translations';

const Error: React.FC<{}> = ({}) => (
  <div className="flex justify-center h-full py-40">
    <p>
      <T kind="An error occurred, please refresh the page and try again" />
    </p>
  </div>
);

export default observer(Error);
